import React from "react";
import { Container, SpaceBetween, Box, Link } from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import SectionHeader from "../../common/SectionHeader";
import { KEY_LAUNCHES } from "../../../config/key-launches";

const KeyLaunchesSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        title="Key Launches"
        variant="h2"
        icon={<Icon name="upload" />}
        useGradient={true}
      />
      <Container>
        <div style={{ maxHeight: "640px", overflowY: "auto" }}>
          <SpaceBetween size="s">
            {KEY_LAUNCHES.map((launch, index) => (
              <div key={index} className="launch-item">
                <SpaceBetween size="xxs">
                  <Box fontWeight="heavy">
                    <Link
                      href={launch.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="secondary"
                      fontSize="heading-xs"
                    >
                      {launch.title}
                    </Link>
                  </Box>
                  <Box fontSize="body-s" color="text-body-secondary">
                    Launched on {launch.date}
                  </Box>
                </SpaceBetween>
              </div>
            ))}
          </SpaceBetween>
        </div>
      </Container>
    </Box>
  );
};

export default KeyLaunchesSection;
